<template>
  <div>
    <div v-if="showData" class="row justify-content-center bg-light border rounded py-2 shadow">
      <div class="col-lg-12 py-2 px-4 ">
        <div class="d-flex justify-content-between mb-2">
          <h5>{{ name }}</h5>

          <a href="#" @click.prevent="openList">
            <i style="font-size:18px" class="mt-1 fas fa-times"></i>
          </a>
        </div>

        <div>{{ Company }}</div>
        <div style="word-break:break-all;width:250px">{{ email }}</div>
        <router-link to="/Edit">
          <p class="mt-2 text-primary">Edit</p>
        </router-link>

        <hr />

        <router-link :to="`/FavoriteExhibitors/Page=${1}`">
          <div class="mb-2 pointer text-primary">
            Favorites
          </div>
        </router-link>

        <router-link :to="`/BrowsingHistoryExhibitors/Page=${1}`">
          <div class="mb-2 pointer text-primary">
            Browsing History
          </div>
        </router-link>
      </div>

      <div class="btn btn-primary text-center mb-3 px-4" @click="logout()">Logout</div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        email: '',
        name: '',
        Company: '',
        showData: false,
      }
    },

    methods: {
      logout() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/Logout'

        vm.$http.get(url).then(function(response) {
          alert('Logout successfully')

          sessionStorage.removeItem('Exhurl')

          window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
        })
      },

      openList() {
        if (this.ListStatus) {
          this.$store.dispatch('updateList', false)
        } else {
          this.$store.dispatch('updateList', true)
        }
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'exhcode']),
    },

    created() {
      const vm = this

      vm.showData = false

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
        vm.email = response.data.email
        vm.name = response.data.cname
        vm.Company = response.data.company
        vm.showData = true
      })
    },
  }
</script>

<style lang="scss" scoped>
  .mesbadge {
    position: relative;

    transform: translate(-50px, 15px);
    font-size: 11px;
    background-color: #e0492e;
    color: #fff;
  }

  .nav_top {
    border-bottom: rgb(207, 207, 207) solid 1px;
  }

  .navbarTopic {
    margin-right: 280px;
  }

  .navbarGap {
    margin-right: 70px;
  }

  .TopicStyle {
    color: #e50000;
    font-size: 20px;
    font-weight: bold;
  }

  .dropdown-item {
    display: block;
    width: 100%;
    padding: 1.5rem 2rem;
    clear: both;
    font-weight: 600;
    color: #252525;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0px;
  }

  .client {
    width: 900px;
    height: 590px;
  }
</style>
